import * as React from 'react';
import BlockComponent from './blockComponent';
const PageLayout = ({ page, html_id, className, currentLocaleCode }) => {
  return (
    <>
      <div
        {...(html_id && { id: html_id })}
        className={`${className ? className : ''} w-full grid grid-cols-12`}
      >
        {page.modular_blocks?.map((block, index) => (
          <BlockComponent key={String(index)} block={block} currentLocaleCode={currentLocaleCode} />
        ))}
      </div>
    </>
  );
};
export default PageLayout;
